var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"upload-video"}},[_c('van-uploader',{attrs:{"after-read":_vm.onAdd,"multiple":"","accept":"video/*"}},[_c('div',[_vm._v("上传视频")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }